// ChatContext/index.ts
import { createContext, useContext } from "react";

import { API_DATA_SOURCES, API_PARAMETERS } from "../../configuration/genovAiConfig"; 

export interface iChatUserContext {
  currChat: any;
  currHistory: any;
  userAsks: any;
  iaAnswers: any;
  accessToken: string | null;
  cancelReponse: boolean;
  isLoading: boolean;
  filesSelected: any[];
  isUploading: boolean;
  isResponseProcess: boolean;
  setCurrChat: (currChat: any) => void;
  setCurrHistory: (currHistory: any) => void;
  setUserAsks: (userAsks: any) => void;
  setIaAnswers: (iaAnswers: any) => void;
  setIsLoading: (value: boolean) => void;
  setFilesSelected: (filesSelected: any) => void;
  setIsUploading: (isUploading: boolean) => void;
  setIsResponseProcess: (isResponseProcess: boolean) => void;
}

export const ChatUserContext = createContext<iChatUserContext | null>(null);

export const InitalChatRequest = {
    data_sources: [API_DATA_SOURCES],
    ...API_PARAMETERS,
}

export const useAppContext = () => {
    return useContext(ChatUserContext);
}

